import React from "react";
import "./FooterBar.css";

interface Props {}

function FooterBar(props: Props) {
  return (
    <footer className="footer-bar">
      <small>Copyright Curtis Voorhees 2026</small>
    </footer>
  );
}

export default FooterBar;
